import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiClient } from '@/lib/api-client';

/** A proxy-ingress server with its live browser-proxy session count. */
export interface ProxyIngressServer {
  name: string;
  publicIp: string;
  region: string | null;
  status: string;
  activeSessions: number;
}

/** Response of `GET /api/proxy/sessions/stats` — the proxy-ingress overview. */
export interface ProxyStats {
  totalActive: number;
  servers: ProxyIngressServer[];
}

/**
 * Proxy-ingress overview — every active proxy-ingress server and its live
 * browser-extension session count, derived server-side from Redis. Admin-only
 * endpoint; polled on the same 30s cadence as the rest of the radiator.
 */
export function useProxyStats(): UseQueryResult<ProxyStats, Error> {
  return useQuery({
    queryKey: ['proxy', 'stats'],
    queryFn: async ({ signal }) =>
      apiClient.get<ProxyStats>('/proxy/sessions/stats', signal),
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
}
